import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DollarSign, Users, TrendingUp, Shield, Globe, Heart } from 'lucide-react';
import '../../../assets/css/student/home/ConservationSection.css';

const ConservationSection = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSeeWork = () => {
    setLoading(true);
    setTimeout(() => {
      navigate('/blogs');
    }, 1500);
  };

  const features = [
    {
      icon: DollarSign,
      title: "Transparent operations",
      description: "We uphold transparency in all our operations, ensuring your donations directly impact lives."
    },
    {
      icon: Users,
      title: "Community partnerships",
      description: "Collaborating with local organizations and leaders to implement effective solutions."
    },
    {
      icon: TrendingUp,
      title: "Accountability & reporting",
      description: "Providing detailed reports, displaying the tangible outcomes of your contributions."
    },
    {
      icon: Shield,
      title: "Empowering futures",
      description: "Our programs focus on long-term, empowering communities to break the cycle of poverty."
    },
    {
      icon: Globe,
      title: "Global reach",
      description: "Operating across multiple countries, we address diverse challenges and leverage local expertise."
    },
    {
      icon: Heart,
      title: "Volunteer opportunities",
      description: "Engage with us through volunteer programs, becoming directly involved in projects."
    }
  ];

  return (
    <div className="cons-section">
      <svg className="cons-decorative-line-top" viewBox="0 0 400 400">
        <path d="M 50 200 Q 150 50 250 150" className="cons-decorative-path" />
        <ellipse cx="80" cy="250" rx="30" ry="50" className="cons-decorative-path" />
      </svg>

      <svg className="cons-decorative-line-bottom" viewBox="0 0 600 400">
        <path d="M 100 50 Q 300 150 500 100" className="cons-decorative-path" />
        <path d="M 200 300 Q 400 350 600 400" className="cons-decorative-path" />
      </svg>

      <div className="cons-container">
        <div className="cons-header">
          <p className="cons-subtitle">
            A partnership approach to sustainable conservation
          </p>
          <h1 className="cons-title">
            Choose us for impactful change<br />
            in global communities
          </h1>
        </div>

        <div className="cons-features-grid">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div key={index} className="cons-feature-card">
                <div className="cons-feature-icon-wrapper">
                  <Icon className="cons-feature-icon" size={48} strokeWidth={1.5} />
                </div>
                <h3 className="cons-feature-title">{feature.title}</h3>
                <p className="cons-feature-description">{feature.description}</p>
              </div>
            );
          })}
        </div>

        {/* CTA Button */}
        <div className="cons-cta-section">
          <button
            className={`cons-cta-button ${loading ? 'cons-cta-loading' : ''}`}
            onClick={handleSeeWork}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="cons-spinner"></span>
                Loading...
              </>
            ) : (
              <>
                See our work
                <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConservationSection;